import I18n from 'app/i18n';

export const firstElementResponse = (response : Response): string => response.responseJSON
    ? Object.values(response.responseJSON)[0][0]
    : I18n.t('server_error_try_again');

interface Response {
    responseJSON: []
}
